import { all, fork, put, takeEvery } from "redux-saga/effects";

import {

    // User Management
    SETTING_LOAD_PERMISSION,
    // SETTING_LOAD_PERMISSION_SUCCESS,
    SETTING_CREATE_PERMISSION,
    SETTING_UPDATE_PERMISSION,
    SETTING_DELETE_PERMISSION,

    SETTING_LOAD_USER,
    // SETTING_LOAD_USER_SUCCESS,
    SETTING_CREATE_USER,
    SETTING_UPDATE_USER,
    SETTING_DELETE_USER,

    SETTING_CREATE_USER_PASS,
    SETTING_RESET_USER_PASS
    // END User Management

} from "../../actions";

import {
    // User Management

    settingGetPermission,
    settingAddPermission,
    settingUpdatePermission,
    settingDeletePermission,

    settingGetUser,
    settingAddUser,
    settingUpdateUser,
    settingDeleteUser,

    settingCreateUserPassword,
    settingResetPassword,

    // END User Management

} from "../../../helpers/setting-api";

import {
    getPermission,
    getPermissionSuccess,
    getUser,
    getUserSuccess,
} from "./actions";

import { NotificationManager } from '../../../components/common/react-notifications';

const PullNotificationManager = async (text) => {
    // eslint-disable-next-line no-return-await
    await NotificationManager.warning(text, 'Error', 3000, null, null, '');
}

// User Management
function* settingManagementLoadPermission({ payload, token }) {
    try {
        const dataRes = yield settingGetPermission(payload, token);
        if (dataRes.status === 'success') {
            // let list = [];

            const dataFilter = dataRes.data.filter(el => el.name_permission === "Owner")
            const allDataFilter = dataRes.data.filter(el => el.name_permission !== "Owner")
            const checkDataFilter = [...dataFilter || (null), ...allDataFilter || dataRes.data]
            const list = checkDataFilter.map(item => (
                {
                    ...item,
                    label: item.name_permission,
                    value: item.id_permission,
                }
            ));
            yield put(getPermissionSuccess(checkDataFilter, list));
        } else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementAddPermission({ payload, token }) {
    try {
        const dataRes = yield settingAddPermission(payload, token);
        if (dataRes.status === 'success') {
            yield put(getPermission({ spa_id: payload.spa_id }, token));
        } else
            if
                (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }

            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else {
                yield PullNotificationManager(`${dataRes.msg}`);
            }

    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementUpdatePermission({ payload, token }) {
    try {
        const dataRes = yield settingUpdatePermission(payload, token);
        if (dataRes.status === 'success') {
            yield put(getPermission({ spa_id: payload.spa_id }, token));
            yield put(getUser({ spa_id: payload.spa_id }, token));
            // yield put(getPosition({ idHotel }, token));
            // yield put(getUser());
        } else
            if (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }
            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementDeletePermission({ payload, token }) {
    const { items } = payload;
    try {
        const dataRes = yield settingDeletePermission(items, token);
        if (dataRes.status === 'success') yield put(getPermission({ spa_id: payload.spa_id }, token));
        else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else if (dataRes.err.code === "ER_ROW_IS_REFERENCED_2") {
                yield PullNotificationManager("RoleCategory is used.");
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        console.log('error', error)
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementLoadUser({ payload, token }) {
    try {
        const dataRes = yield settingGetUser(payload, token);
        if (dataRes.status === 'success') {
            const dataFilter = dataRes.data.filter(el => el.name_permission === "Owner")
            const allDataFilter = dataRes.data.filter(el => el.name_permission !== "Owner")
            const checkDataFilter = [...dataFilter || (null), ...allDataFilter || dataRes.data]
            const list = checkDataFilter.map(item => (
                {
                    ...item,
                    label: `${item.first_name} ${item.last_name}`,
                    value: item.id_permission,
                }
            ));
            yield put(getUserSuccess(checkDataFilter, list));
        } else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementAddUser({ payload, token }) {
    try {
        const dataRes = yield settingAddUser(payload, token);
        if (dataRes.status === 'success') {
            yield put(getUser({ spa_id: payload.spa_id }, token));
        } else
            if
                (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }

            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else {
                yield PullNotificationManager(`${dataRes.msg}`);
            }

    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementUpdateUser({ payload, token }) {
    try {
        const dataRes = yield settingUpdateUser(payload, token);
        if (dataRes.status === 'success') {
            yield put(getUser({ spa_id: payload.spa_id }, token));
            // yield put(getPosition({ idHotel }, token));
            // yield put(getUser());
        } else
            if (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }
            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementDeleteUser({ payload, token }) {
    const { items } = payload;
    try {
        const dataRes = yield settingDeleteUser(items, token);
        if (dataRes.status === 'success') yield put(getUser({ spa_id: payload.spa_id }, token));
        else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else if (dataRes.err.code === "ER_ROW_IS_REFERENCED_2") {
                yield PullNotificationManager("RoleCategory is used.");
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        console.log('error', error)
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementCreateUserPassword({ payload, token }) {
    try {
        // const { spa_id } = payload;
        // let token = localStorage.getItem('token')
        const dataRes = yield settingCreateUserPassword(payload, token);
        if (dataRes.status === 'success') {
            yield put(getUser({ spa_id: payload.spa_id }, token));
        } else
            if (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data username is duplicated. Please change the data username.");
            }
            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager(`${dataRes.msg}`);
            }

    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}
function* settingManagementResetPassword({ payload, token }) {
    // const { spa_id } = payload;
    try {
        const dataRes = yield settingResetPassword(payload, token);
        if (dataRes.status === 'success') {
            yield put(getUser({ spa_id: payload.spa_id }, token));
            // const resetStatus = dataRes.status.toString()
            // console.log('dataRes.status', dataRes.status)
        } else
            if (dataRes.status === 'error' && dataRes.auth === false) {

                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager(`${dataRes.msg}`);
            }
    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}
// END User Management

// User Management
export function* watchLoadPermission() {
    yield takeEvery(
        SETTING_LOAD_PERMISSION,
        settingManagementLoadPermission
    );
}
export function* watchAddPermission() {
    yield takeEvery(
        SETTING_CREATE_PERMISSION,
        settingManagementAddPermission
    );
}
export function* watchUpdatePermission() {
    yield takeEvery(
        SETTING_UPDATE_PERMISSION,
        settingManagementUpdatePermission
    );
}
export function* watchDeletePermission() {
    yield takeEvery(
        SETTING_DELETE_PERMISSION,
        settingManagementDeletePermission
    );
}

export function* watchLoadUser() {
    yield takeEvery(
        SETTING_LOAD_USER,
        settingManagementLoadUser
    );
}
export function* watchAddUser() {
    yield takeEvery(
        SETTING_CREATE_USER,
        settingManagementAddUser
    );
}
export function* watchUpdateUser() {
    yield takeEvery(
        SETTING_UPDATE_USER,
        settingManagementUpdateUser
    );
}
export function* watchDeleteUser() {
    yield takeEvery(
        SETTING_DELETE_USER,
        settingManagementDeleteUser
    );
}

export function* watchCreateUserPassword() {
    yield takeEvery(
        SETTING_CREATE_USER_PASS,
        settingManagementCreateUserPassword
    );
}
export function* watchResetPassword() {
    yield takeEvery(
        SETTING_RESET_USER_PASS,
        settingManagementResetPassword
    );
}

// END User Management

export default function* rootSaga() {
    yield all([
        //  User Management
        fork(watchLoadPermission),
        fork(watchAddPermission),
        fork(watchUpdatePermission),
        fork(watchDeletePermission),

        fork(watchLoadUser),
        fork(watchAddUser),
        fork(watchUpdateUser),
        fork(watchDeleteUser),

        fork(watchCreateUserPassword),
        fork(watchResetPassword),
    ])
}